import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Carousel, CarouselItem, CarouselControl, CarouselIndicators } from "reactstrap";
import yahooPlacement from "../../../assets/images/ad_preview/yahoo.png";
import siPlacement from "../../../assets/images/ad_preview/si.png";
import AdDesignPreview from "../../partner-dashboard/components/ad-designs/ad-design-preview";
import "./preview-carousel.styles.scss";
import "./phone-placeholder.styles.scss";

const propTypes = {
  template: PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    previewPath: PropTypes.string.isRequired,
    placements: PropTypes.arrayOf(PropTypes.string).isRequired,
    primaryMimeType: PropTypes.string.isRequired
  }).isRequired
};

const items = [
  {
    key: "yahoo",
    src: yahooPlacement,
    altText: "Yahoo!",
    // coefficient by which to scale the ad preview
    adScale: 0.76,
    topPosition: "12.7%",
    leftPosition: "12.6%"
  },
  {
    key: "si",
    src: siPlacement,
    altText: "Sports Illustrated",
    adScale: 0.79,
    topPosition: "24.2%",
    leftPosition: "11.1%"
  }
];

const MobilePreviewCarousel = ({ template }) => {
  const ref = useRef(null);
  const containerWidth = 378;
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const MOBILE_SIZE_RATIO = 0.15;

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = newIndex => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const slides = items.map(item => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.key}
      >
        <div
          className="ad-design__carousel--sample-placement-bg"
          style={{
            backgroundImage: `url("${item.src}")`,
            width: containerWidth,
            height: 700
          }}
        >
          <div
            style={{
              position: "absolute",
              top: item.topPosition,
              left: item.leftPosition,
              width: containerWidth * item.adScale,
              height: containerWidth * item.adScale * MOBILE_SIZE_RATIO
            }}
          >
            <AdDesignPreview
              url={template.previewPath}
              mimeType={template.primaryMimeType}
              title={template.displayName}
              width={containerWidth * item.adScale}
              height={containerWidth * item.adScale * MOBILE_SIZE_RATIO}
              exactSize
            />
          </div>
        </div>
      </CarouselItem>
    );
  });

  return (
    <div ref={ref} className="py-0">
      <div className="ad-preview__iphone-placeholder">
        <div className="ad-preview__iphone-placeholder-container">
          <Carousel
            className="ad-design__carousel"
            activeIndex={activeIndex}
            next={next}
            previous={previous}
          >
            <CarouselIndicators
              items={items}
              activeIndex={activeIndex}
              onClickHandler={goToIndex}
            />
            {slides}
            <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
            <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
          </Carousel>
        </div>
      </div>
      <small className="pt-3">
        * The above sample placements are for example purposes only. Your specific ad may be
        displayed on other websites.
      </small>
    </div>
  );
};

MobilePreviewCarousel.propTypes = propTypes;

export default MobilePreviewCarousel;
